import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    // {
    //   path: '/',
    //   name: 'home',
    //   component: () => import('./views/LoginView.vue')
    // },
    {
      path: '/',
      name: 'about',
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: "/contact_us",
      name: "ContactView",
      component: () =>
          import("./views/ContactView.vue")
    },
    {
      path: '/login',
      name: 'LoginView',
      component: () => import('./views/LoginView.vue')
    },
    {
      path: '/register',
      name: 'RegisterView',
      component: () => import('./views/RegisterView.vue')
    },
    {
      path: '/menu',
      name: 'MenuView',
      component: () => import('./views/MenuView.vue')
    },
    {
      path: '/',
      name: 'DrowningView',
      component: () =>
          import('./views/drowningLayouts/DrowningView.vue'),
      children:[
        {
          path: '/event-form',
          name: 'EventForm',
          props: true,
          component: () =>
              import('./components/drowning/EventForm.vue')
        },
        {
          path: '/drowning-form',
          name: 'DrowningForm',
          props: true,
          component: () =>
              import('./components/drowning/DrowningForm.vue')
        }
      ]
    },
    {
      path: '/',
      name: 'StatusView',
      component: () =>
          import('./views/drowningLayouts/StatusView.vue'),
      children:[
        {
          path: '/status',
          name: 'Status',
          props: true,
          component: () =>
              import('./components/drowning/Status.vue')
        },
      ]
    },

    {
      path: "/",
      name: "FooterView",
      component: () =>
          import("./views/FooterView.vue")
    },
  ]
})
